export default __webpack_public_path__ + "static/media/backgroundNotAllowLocation.8852eaeb.png";